var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass:
        "badge d-inline-flex align-items-center font-weight-normal font-size-100",
      class: _vm.addMarginClass ? _vm.classes + " mr-2_" : _vm.classes,
      attrs: { title: _vm.title ? _vm.title : null },
    },
    [
      _vm._t("default", function () {
        return [
          _vm.isIconBeforeText && _vm.icon
            ? _c("i", { class: _vm.text ? _vm.icon + " mr-2_" : _vm.icon })
            : _vm._e(),
          _vm._v(" "),
          _vm.text ? [_vm._v(_vm._s(_vm.text))] : _vm._e(),
          _vm._v(" "),
          !_vm.isIconBeforeText && _vm.icon
            ? _c("i", { class: _vm.text ? _vm.icon + " ml-2_" : _vm.icon })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }